/**
 * Learn more about createBottomTabNavigator:
 * https://reactnavigation.org/docs/bottom-tab-navigator
 */
import { AntDesign } from "@expo/vector-icons";
import { Ionicons } from "@expo/vector-icons";
import { Feather } from "@expo/vector-icons";
import { MaterialIcons } from "@expo/vector-icons";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { Entypo } from "@expo/vector-icons";
import {
  BottomTabNavigationOptions,
  BottomTabNavigationProp,
  createBottomTabNavigator,
} from "@react-navigation/bottom-tabs";
import {
  createStackNavigator,
  StackNavigationProp,
} from "@react-navigation/stack";
import * as React from "react";
import Colors, { kcColor } from "../constants/Colors";
import useColorScheme from "../hooks/useColorScheme";
import TabQuoteScreen from "../screens/TabQuoteScreen";
import TabQuoteScreen_Add from "../screens/TabQuoteScreen_Add";
import TabQuoteScreen_Modify from "../screens/TabQuoteScreen_Modify";
import TabQuoteScreen_Info from "../screens/TabQuoteScreen_CommodityInfo";
import TabQuoteScreen_SelectCommodity from "../screens/TabQuoteScreen_SelectCommodity";
import TabTECPScreen from "../screens/TabTECPScreen";
import TECPSettingScreen from "../screens/TabTECPScreen_Setting";
import TabSettingScreen from "../screens/TabSettingScreen";
import {
  BottomTabParamList,
  TabQuoteParamList,
  TabTECPParamList,
  TabSettingParamList,
  RootStackParamList,
  CommodityInfoProps,
} from "../types";
import { ActionSheetProvider } from "@expo/react-native-action-sheet";
import {
  CompositeNavigationProp,
  getFocusedRouteNameFromRoute,
  Route,
  PartialRoute,
} from "@react-navigation/native";
import {
  TabTECPScreen_Setting_BBand,
  TabTECPScreen_Setting_G_HLine,
  TabTECPScreen_Setting_KD,
  TabTECPScreen_Setting_KLine_Color,
  TabTECPScreen_Setting_KLine_Type,
  TabTECPScreen_Setting_MA,
  TabTECPScreen_Setting_MACD,
  TabTECPScreen_Setting_RSI,
} from "../screens/TECPSettingSubScreen";
import { View, Text } from "react-native";
import { LabelPosition } from "@react-navigation/bottom-tabs/lib/typescript/src/types";
import { GetText } from "../Locales";

export const DocumentTitle = "Fintech-Trader";
const ReflashAutoNavigate = false; // 子頁面重新整理時自動跳回子頁面, false時回到預設頁面(Ex.下單會回到庫存頁面)

export type IBottomTabProp = {
  route: any;
  navigation: StackNavigationProp<RootStackParamList, "Root">;
};

var BottomTabScreenSize: { Width: number; Height: number } = {
  Width: 0,
  Height: 0,
};
var OnHeightToLowChanged: ((_ToLow: boolean) => void) | undefined = undefined;
export var ToLowCallback = (_f: (_ToLow: boolean) => void) => {
  OnHeightToLowChanged = _f;
};
export var IsBottomTabHieghtToLow = () => {
  return BottomTabScreenSize.Height < 500;
};
const BottomTab = createBottomTabNavigator<BottomTabParamList>();
export default function BottomTabNavigator(_Props: IBottomTabProp) {
  const colorScheme = useColorScheme();

  const [ScreenSize, SetScreenSize] = React.useState(BottomTabScreenSize);

  const IsFocusTECPScreen =
    getFocusedRouteNameFromRoute(_Props.route) === "TabTECP";

  return (
    <View
      style={{ flex: 1, backgroundColor: kcColor("Background"), padding: 0 }}
      onLayout={(e) => {
        let Size = {
          Width: e.nativeEvent.layout.width,
          Height: e.nativeEvent.layout.height,
        };
        BottomTabScreenSize = Size;
        SetScreenSize(Size);
        OnHeightToLowChanged?.(IsBottomTabHieghtToLow());
      }}
    >
      <ActionSheetProvider>
        <BottomTab.Navigator
          initialRouteName="TabQuote"
          /* --------------------------------- */
          // initialRoute 返回初始選項卡
          // order 返回上一個選項卡（按照它們在選項卡欄中顯示的順序）
          // history 返回上次訪問的選項卡
          // none 不處理後退按鈕
          backBehavior="none"
          /* --------------------------------- */
          lazy={false}
          detachInactiveScreens={true}
          tabBarOptions={{
            // activeBackgroundColor: "rgb(18, 18, 18)", // 選取的icon底色
            activeTintColor: Colors[colorScheme].tint, // 選取的icon顏色
            // inactiveTintColor: "yellow", // 未選取的icon底色
            // inactiveBackgroundColor: "rgb(18, 18, 18)", // 未選取的icon顏色
            //showLabel: false, // 關掉Icon旁邊的文字
            style: {
              //borderTopWidth: 0,
              //borderTopColor: "rgb(18, 18, 18)",
              //maxHeight: ShowBottomTab ? 60 : 1,
            },
          }}
          tabBar={
            !IsBottomTabHieghtToLow() || !IsFocusTECPScreen
              ? undefined
              : (_SProp) => {
                  return (
                    <View
                      style={{
                        width: 1,
                        height: 1,
                        backgroundColor: "#00000000",
                      }}
                    />
                  );
                }
          }
          screenOptions={({ route }) => {
            let ret: BottomTabNavigationOptions = {
              tabBarVisibilityAnimationConfig: {
                show: { animation: "timing", config: { duration: 1 } }, // 設0有機會在手機瀏覽器上被判錯高度導致tabBar跑道螢幕範圍外
                hide: { animation: "timing", config: { duration: 1 } },
              },
            };

            // // 隱藏按鈕
            // if (["TabOrder"].includes(route.name)) {
            //   ret.tabBarButton = () => {
            //     return null;
            //   };
            // }

            return ret;
          }}
        >
          <BottomTab.Screen
            name="TabQuote"
            component={TabQuoteNavigator}
            options={{
              title: DocumentTitle,
              tabBarLabel: (_Prop) =>
                Render_BottomTabLable(_Prop, GetText("Screen_Quote")),
              tabBarIcon: ({ color }) => (
                <TabBarIcon_Feather name="activity" color={color} size={30} />
              ),
            }}
            initialParams={{ screen: TabQuoteInitScreen }}
            // initialParams={{
            //   state: {
            //     index: 0,
            //     routes: [{ name: TabQuoteInitScreen, params: undefined }],
            //     stale: true,
            //   },
            // }}
          />
          <BottomTab.Screen
            name="TabTECP"
            component={TabTECPNavigator}
            options={{
              title: DocumentTitle,
              tabBarLabel: (_Prop) =>
                Render_BottomTabLable(_Prop, GetText("Screen_TECP")),
              tabBarIcon: ({ color }) => (
                <TabBarIcon_Antd name="linechart" color={color} size={30} />
              ),
            }}
            initialParams={{ screen: TabTECPInitScreen }}
            // listeners={{
            //   tabPress: (e) => {
            //     BottomTab_OnTabPress(_Props, e, "Root", { screen: "TabTECP" });
            //   },
            // }}
          />
          <BottomTab.Screen
            name="TabSetting"
            component={TabSettingNavigator}
            options={{
              title: DocumentTitle,
              tabBarLabel: (_Prop) =>
                Render_BottomTabLable(_Prop, GetText("Screen_Account")),
              tabBarIcon: ({ color }) => (
                <TabBarIcon_MaterialCommunityIcons
                  name="account-outline"
                  size={32}
                  color={color}
                />
              ),
            }}
            // listeners={{
            //   tabPress: (e) => {
            //     BottomTab_OnTabPress(_Props, e, "Root", {
            //       screen: "TabSetting",
            //       params: { screen: "TabSettingScreen" },
            //     });
            //   },
            // }}
          />
        </BottomTab.Navigator>
      </ActionSheetProvider>
    </View>
  );
}
function Render_BottomTabLable(
  _Prop: {
    focused: boolean;
    color: string;
    position: LabelPosition;
  },
  _szText: string
) {
  return (
    <Text
      selectable={false}
      style={{
        fontSize: _Prop.position == "beside-icon" ? 14 : 12, //12 : 10,
        color: _Prop.color,
        marginLeft: _Prop.position == "beside-icon" ? 20 : 0,
      }}
    >
      {_szText}
    </Text>
  );
}

// You can explore the built-in icon families and icons on the web at:
// https://icons.expo.fyi/
function TabBarIcon_Ionicons(props: {
  name: React.ComponentProps<typeof Ionicons>["name"];
  color: string;
  size: number;
}) {
  return (
    <Ionicons selectable={false} style={{ marginBottom: -3 }} {...props} />
  );
}
function TabBarIcon_Antd(props: {
  name: React.ComponentProps<typeof AntDesign>["name"];
  color: string;
  size: number;
}) {
  return (
    <AntDesign selectable={false} style={{ marginBottom: -3 }} {...props} />
  );
}
function TabBarIcon_Feather(props: {
  name: React.ComponentProps<typeof Feather>["name"];
  color: string;
  size: number;
}) {
  return <Feather selectable={false} style={{ marginBottom: -3 }} {...props} />;
}
function TabBarIcon_Material(props: {
  name: React.ComponentProps<typeof MaterialIcons>["name"];
  color: string;
  size: number;
}) {
  return (
    <MaterialIcons selectable={false} style={{ marginBottom: -3 }} {...props} />
  );
}
function TabBarIcon_MaterialCommunityIcons(props: {
  name: React.ComponentProps<typeof MaterialCommunityIcons>["name"];
  color: string;
  size: number;
}) {
  return (
    <MaterialCommunityIcons
      selectable={false}
      style={{ marginBottom: -3 }}
      {...props}
    />
  );
}
function TabBarIcon_Entypo(props: {
  name: React.ComponentProps<typeof Entypo>["name"];
  color: string;
  size: number;
}) {
  return <Entypo selectable={false} style={{ marginBottom: -3 }} {...props} />;
}

// Each tab has its own navigation stack, you can read more about this pattern here:
// https://reactnavigation.org/docs/tab-based-navigation#a-stack-navigator-for-each-tab
const TabQuoteStack = createStackNavigator<TabQuoteParamList>();
export type ITabQuoteProp = {
  route: any;
  navigation: CompositeNavigationProp<
    BottomTabNavigationProp<BottomTabParamList, "TabQuote">,
    StackNavigationProp<RootStackParamList>
  >;
  showActionSheetWithOptions: any;
};
const TabQuoteInitScreen = "TabQuoteScreen";
class TabQuoteNavigator extends React.Component<ITabQuoteProp> {
  constructor(_Props: ITabQuoteProp) {
    super(_Props);
    //this.OnConstructorRefreshHandle();
  }

  // 建構子進來時如果不是報價頁面的特殊處理
  OnConstructorRefreshHandle = () => {
    let FocusScreen = getFocusedRouteNameFromRoute(this.props.route);
    // 在非報價頁面(Ex. Commodity_Add)重新整理時發生, 導到報價頁面
    if (FocusScreen != TabQuoteInitScreen) {
      let ParentState = this.props.navigation.dangerouslyGetState(); // Tab層的State
      // 複製Routes狀態
      let RoutesClone: PartialRoute<
        Route<keyof BottomTabParamList, object | undefined>
      >[] = ParentState.routes.map((v) => {
        return {
          key: v.key,
          name: v.name,
          params: v.params,
        };
      });

      let CurrentRouteIdx = RoutesClone.findIndex((q) => q.name == "TabQuote");
      if (CurrentRouteIdx > -1) {
        // 把這個Route的狀態改成TabQuoteScreen
        RoutesClone[CurrentRouteIdx].state = {
          routes: [{ name: TabQuoteInitScreen }],
          stale: true,
        };
        // 重設回到報價頁面
        this.props.navigation.reset({
          index: ParentState.index,
          routes: RoutesClone,
          stale: true,
        });

        /* ----------------------------------- */
        // 再次跳轉道目標頁面, 會因為上面reset導致畫面閃一下
        if (ReflashAutoNavigate) {
          let TargetState = ParentState.routes[CurrentRouteIdx].state;
          if (TargetState && TargetState.routes.length > 0) {
            let TargetScreen =
              TargetState.routes[TargetState.routes.length - 1];

            setTimeout(() => {
              let Params = TargetScreen.params;
              let szName: keyof TabQuoteParamList =
                TargetScreen.name as keyof TabQuoteParamList;

              if (szName == "TabQuoteScreen_Info") {
                this.props.navigation.navigate("TabQuote", {
                  screen: szName,
                  params: Params as CommodityInfoProps,
                });
              } else {
                this.props.navigation.navigate("TabQuote", {
                  screen: szName,
                  params: Params as undefined, // 這樣as undefined還是會硬把params帶進去, 強制不帶的話要直接拔掉這行
                });
              }
            }, 1);
          }
        }
        /* ----------------------------------- */
      }
    }
  };

  render() {
    let FocusScreen = getFocusedRouteNameFromRoute(this.props.route);
    let ShowTabBar =
      FocusScreen == TabQuoteInitScreen || FocusScreen == undefined;
    setTimeout(() => {
      this.props.navigation.setOptions({
        tabBarVisible: ShowTabBar,
      });
    }, 1);

    return (
      <TabQuoteStack.Navigator initialRouteName={TabQuoteInitScreen}>
        <TabQuoteStack.Screen
          name={TabQuoteInitScreen}
          component={TabQuoteScreen}
          options={{
            title: DocumentTitle,
            headerTitle: GetText("Screen_Quote"),
            headerTitleAlign: "center",
          }}
        />
        <TabQuoteStack.Screen
          name="TabQuoteScreen_Add"
          component={TabQuoteScreen_Add}
          options={{
            title: DocumentTitle,
            headerTitle: "增加商品",
            headerTitleAlign: "center",
          }}
        />
        <TabQuoteStack.Screen
          name="TabQuoteScreen_Modify"
          component={TabQuoteScreen_Modify}
          options={{
            title: DocumentTitle,
            headerTitle: "編輯",
            headerTitleAlign: "center",
          }}
        />
        <TabQuoteStack.Screen
          name="TabQuoteScreen_Info"
          component={TabQuoteScreen_Info}
          options={{
            title: DocumentTitle,
            headerTitle: "商品規格",
            headerTitleAlign: "center",
          }}
        />
      </TabQuoteStack.Navigator>
    );
  }
}

const TabTECPInitScreen = "TabTECPScreen";
const TabTECPStack = createStackNavigator<TabTECPParamList>();
export type ITabTECPProp = {
  route: any;
  navigation: CompositeNavigationProp<
    BottomTabNavigationProp<BottomTabParamList, "TabTECP">,
    StackNavigationProp<RootStackParamList>
  >;
};
class TabTECPNavigator extends React.Component<ITabTECPProp> {
  constructor(_Props: ITabTECPProp) {
    super(_Props);
  }

  render() {
    let FocusScreen = getFocusedRouteNameFromRoute(this.props.route);
    let ShowTabBar =
      FocusScreen == TabTECPInitScreen || FocusScreen == undefined;
    setTimeout(() => {
      this.props.navigation.setOptions({
        tabBarVisible: ShowTabBar,
      });
    }, 1);

    return (
      <TabTECPStack.Navigator initialRouteName={TabTECPInitScreen}>
        <TabTECPStack.Screen
          name={TabTECPInitScreen}
          component={TabTECPScreen}
          options={{
            title: DocumentTitle,
            headerTitle: GetText("Screen_TECP"),
            headerTitleAlign: "center",
          }}
        />
        <TabTECPStack.Screen
          name="TabTECPScreen_Info"
          component={TabQuoteScreen_Info}
          options={{
            title: DocumentTitle,
            headerTitle: "商品規格",
            headerTitleAlign: "center",
          }}
        />
        <TabTECPStack.Screen
          name="TabTECPScreen_Select"
          component={TabQuoteScreen_SelectCommodity}
          options={{
            title: DocumentTitle,
            headerTitle: "商品列表",
            headerTitleAlign: "center",
          }}
        />
        <TabTECPStack.Screen
          name="TabTECPScreen_Setting"
          component={TECPSettingScreen}
          options={{
            title: DocumentTitle,
            headerTitle: "指標設定",
            headerTitleAlign: "center",
          }}
        />
        {/* <TabTECPStack.Screen
          name="TabTECPScreen_Setting_BBand"
          component={TabTECPScreen_Setting_BBand}
          options={{ headerTitle: "MA", headerTitleAlign: "center" }}
        />
        <TabTECPStack.Screen
          name="TabTECPScreen_Setting_KD"
          component={TabTECPScreen_Setting_KD}
          options={{ headerTitle: "MA", headerTitleAlign: "center" }}
        /> */}
        <TabTECPStack.Screen
          name="TabTECPScreen_Setting_KLine_Color"
          component={TabTECPScreen_Setting_KLine_Color}
          options={{
            title: DocumentTitle,
            headerTitle: "MA",
            headerTitleAlign: "center",
          }}
        />
        <TabTECPStack.Screen
          name="TabTECPScreen_Setting_G_HLine"
          component={TabTECPScreen_Setting_G_HLine}
          options={{
            title: DocumentTitle,
            headerTitle: "MA",
            headerTitleAlign: "center",
          }}
        />
        <TabTECPStack.Screen
          name="TabTECPScreen_Setting_KLine_Type"
          component={TabTECPScreen_Setting_KLine_Type}
          options={{
            title: DocumentTitle,
            headerTitle: "MA",
            headerTitleAlign: "center",
          }}
        />
        {/* <TabTECPStack.Screen
          name="TabTECPScreen_Setting_MA"
          component={TabTECPScreen_Setting_MA}
          options={{ headerTitle: "MA", headerTitleAlign: "center" }}
        />
        <TabTECPStack.Screen
          name="TabTECPScreen_Setting_MACD"
          component={TabTECPScreen_Setting_MACD}
          options={{ headerTitle: "MA", headerTitleAlign: "center" }}
        />
        <TabTECPStack.Screen
          name="TabTECPScreen_Setting_RSI"
          component={TabTECPScreen_Setting_RSI}
          options={{ headerTitle: "MA", headerTitleAlign: "center" }}
        /> */}
      </TabTECPStack.Navigator>
    );
  }
}

const TabSettingStack = createStackNavigator<TabSettingParamList>();

function TabSettingNavigator() {
  return (
    <TabSettingStack.Navigator>
      <TabSettingStack.Screen
        name="TabSettingScreen"
        component={TabSettingScreen}
        options={{
          title: DocumentTitle,
          headerTitle: "設定",
          headerTitleAlign: "center",
        }}
      />
    </TabSettingStack.Navigator>
  );
}
